export default {
  // 通用
  'pages.common.operation': '操作',

  // FirmwarePackage 韌體包後設資料
  'pages.firmwarePackage.pageTitle': '韌體包後設資料',
  'pages.firmwarePackage.headerTitle': '上傳 OTA 韌體後自動寫入/更新後設資料；可在此設定產線預設包與狀態。',
  'pages.firmwarePackage.editModalTitle': '編輯韌體包',
  'pages.firmwarePackage.fileRelPath': '相對路徑',
  'pages.firmwarePackage.fileSize': '大小',
  'pages.firmwarePackage.isProductionDefault': '產線預設',
  'pages.firmwarePackage.isProductionDefaultLabel': '產線預設包（同型號僅建議一條）',
  'pages.firmwarePackage.remark': '備註',
  'pages.firmwarePackage.saved': '已儲存',

  // OTAVersionPanel OTA 版本管理
  'pages.otaVersion.cardTitle': 'OTA版本管理',
  'pages.otaVersion.waitingServerResponse': '等待伺服器響應...',
  'pages.otaVersion.uploadFailedStatus': '上傳失敗 ({status}): {detail}',
  'pages.otaVersion.networkError': '網路錯誤',
  'pages.otaVersion.uploadTimeout': '上傳超時',
  'pages.otaVersion.createSuccess': '裝置版本建立成功',
  'pages.otaVersion.createFailed': '建立失敗，請重試',
  'pages.otaVersion.versionCountLabel': '{count}個版本',
  'pages.otaVersion.uploadProgress': '上傳進度：',
  'pages.otaVersion.deviceNamePlaceholder': '輸入裝置名稱過濾',
  'pages.otaVersion.deviceTypePlaceholder': '輸入裝置型號過濾',
  'pages.otaVersion.addDeviceVersion': '新增裝置版本',
  'pages.otaVersion.total': '共 {total} 條',
  'pages.otaVersion.deviceTypeRequired': '請輸入裝置型號',
  'pages.otaVersion.deviceTypeExample': '例如: esp32-s3',
  'pages.otaVersion.deviceName': '裝置名稱',
  'pages.otaVersion.noDeviceName': '未命名',
  'pages.otaVersion.deviceType': '裝置型號',
  'pages.otaVersion.currentVersion': '韌體版本',
  'pages.otaVersion.noVersion': '暫無版本',
  'pages.otaVersion.historyVersions': '歷史版本',
  'pages.otaVersion.noHistoryVersions': '暫無歷史版本',
  'pages.otaVersion.uploadFirmware': '上傳韌體',
  'pages.otaVersion.selectFile': '選擇檔案',
  'pages.otaVersion.delete': '刪除',
  'pages.otaVersion.deleteConfirm': '確認刪除',
  'pages.otaVersion.deleteContent': '確定要刪除該歷史版本嗎？',
  'pages.otaVersion.deleteSuccess': '歷史版本刪除成功',
  'pages.otaVersion.deleteFailed': '歷史版本刪除失敗',
  'pages.otaVersion.fetchFailed': '獲取版本資料失敗',
  'pages.otaVersion.uploadSuccess': '韌體上傳成功',
  'pages.otaVersion.uploadFailed': '韌體上傳失敗',
  'pages.otaVersion.invalidFileName': '檔名格式不正確，必須為xx.yy.zz.bin格式',
  'pages.otaVersion.fileTooLarge': '檔案大小不能超過500MB',
  'pages.otaVersion.versionNotNewer': '上傳的版本必須比當前最新版本新',

  // OpsManage 運維管理
  'pages.admin.ops.waitingServerResponse': '等待伺服器響應...',
  'pages.admin.ops.upload.successToast': '上傳成功！',
  'pages.admin.ops.upload.failedStatus': '上傳失敗 ({status}): {detail}',
  'pages.admin.ops.upload.networkError': '網路錯誤，上傳失敗',
  'pages.admin.ops.upload.timeout': '上傳超時，請重試',
  'pages.admin.ops.upload.canceled': '上傳已取消',
  'pages.admin.ops.serverVersion': 'Server Version',
  'pages.admin.ops.rollbackVersion': 'Rollback Version',
  'pages.admin.ops.rollback.button': '回滾服務',
  'pages.admin.ops.rollback.confirmTitle': '謹慎操作：確認要回滾服務嗎？',
  'pages.admin.ops.rollback.desc': '回滾服務將恢復到上一個版本，當前版本的資料可能會丟失。',
  'pages.admin.ops.rollback.warn': '此操作不可逆，請確保已備份重要資料。',
  'pages.admin.ops.rollback.ok': '確認回滾',
  'pages.admin.ops.rollback.cancel': '取消',
  'pages.admin.ops.rollback.success': '服務回滾指令已傳送',
  'pages.admin.ops.rollback.error': '服務回滾失敗',

  // Product 產品
  'pages.products.deviceType.direct': '直連裝置',
  'pages.products.deviceType.gatewaySub': '閘道器子裝置',
  'pages.products.deviceType.gateway': '閘道器裝置',
  'pages.products.locationType.ip': 'IP定位',
  'pages.products.locationType.deviceReport': '裝置上報',
  'pages.products.locationType.manual': '手動定位',
  'pages.products.netType.other': '其他',
  'pages.products.rule.nameRequired': '請輸入產品名稱',
  'pages.products.rule.codecTypeRequired': '請輸入編解碼器型別',
  'pages.products.rule.productKeyRequired': '請輸入產品標識',
  'pages.products.rule.deviceTypeRequired': '請選擇裝置型別',
  'pages.products.rule.locationTypeRequired': '請選擇定位方式',
  'pages.products.rule.netTypeRequired': '請選擇網路型別',
  'pages.products.addButton': '新增產品',
  'pages.products.create.modal.categoryLabel': '產品分類',
  'pages.products.card.id': 'ID',
  'pages.products.card.confirmDelete': '確認刪除嗎？',
  'pages.products.model.deviceTypeLabel': '裝置型別',
  'pages.products.model.locationTypeLabel': '定位方式',
  'pages.products.model.netTypeLabel': '網路型別',
  'pages.products.model.codecTypeLabel': '編解碼方式',
  'pages.products.save.success': '儲存成功',
  'pages.products.save.failed': '儲存失敗',
  'pages.products.delete.success': '刪除成功',
  'pages.products.delete.failed': '刪除失敗',

  // ProductCategory 產品分類
  'pages.productCategory.rule.nameRequired': '請輸入名稱',
  'pages.productCategory.rule.statusRequired': '請選擇狀態',
  'pages.productCategory.column.ID': 'ID',
  'pages.productCategory.column.ProductCategory.placeholder': '請選擇或搜尋產品裝置型號',

  // ModelProviders 模型供應商
  'pages.admin.providers.typeCount': '{n} 個',

  // RecorderManage 錄音管理
  'pages.admin.recorder.recordCount': '({n} 條)',

  // Settings 系統設定
  'pages.admin.settings.llmOpenSource.label': 'LLM（開源裝置預設）',
  'pages.admin.settings.llmCommercial.label': 'LLM（商業授權裝置預設）',
  'pages.admin.settings.sameAsAbovePlaceholder': '與上方列表一致',
  'pages.admin.settings.llmOpenSource.optionCommercialSuffix': '（需商業授權，不可作開源預設）',
  'pages.admin.settings.error.validation': '請修正表單校驗錯誤後再儲存',
  'pages.admin.settings.error.openSourceLlmCommercial': '開源裝置預設不能選擇需商業授權的 LLM',

  // ContractDevicePanel 協約裝置
  'pages.contractDevice.macPattern': '請輸入正確的MAC地址',

  // SystemConfig 頁頭 / Tab / 充值 / YAML（硬編碼補齊）
  'pages.systemConfig.pageTitle': '系統配置管理',
  'pages.systemConfig.pageSubtitle': '管理系統的各項配置引數',
  'pages.systemConfig.pageAlertTitle': '配置管理說明',
  'pages.systemConfig.pageAlertDesc':
    '在這裡您可以管理系統的各項配置，包括應用程式設定、伺服器配置、認證設定等。修改配置後請及時儲存。',
  'pages.systemConfig.tab.application': '應用配置',
  'pages.systemConfig.tab.transport': '傳輸配置',
  'pages.systemConfig.tab.web': 'Web配置',
  'pages.systemConfig.tab.auth': '認證配置',
  'pages.systemConfig.tab.roles': '角色配置',
  'pages.systemConfig.tab.localMcp': '本地MCP功能',
  'pages.systemConfig.tab.externalMcp': '外部MCP配置',
  'pages.systemConfig.tab.exitCommands': '退出指令',
  'pages.systemConfig.tab.log': '日誌配置',
  'pages.systemConfig.tab.data': '資料配置',
  'pages.systemConfig.tab.quickReply': '快捷回覆',
  'pages.systemConfig.tab.recharge': '充值/支付',
  'pages.systemConfig.tab.yaml': '完整YAML（只讀）',
  'pages.systemConfig.quickReply.addWord': '新增回複詞',
  'pages.systemConfig.yaml.cardTitle': '完整 YAML（server_configs，只讀）',
  'pages.systemConfig.yaml.loadBtn': '從伺服器載入',
  'pages.systemConfig.yaml.placeholder': '點選「從伺服器載入」檢視當前配置',
  'pages.systemConfig.recharge.cardTitle': '充值與微信支付',
  'pages.systemConfig.recharge.enabled': '啟用充值模組',
  'pages.systemConfig.recharge.wechatPayDivider': '微信支付 wechat_pay',
  'pages.systemConfig.recharge.wechatEnabled': '啟用微信支付',
  'pages.systemConfig.recharge.mchId': '商戶號 mch_id',
  'pages.systemConfig.recharge.apiV3Key': 'APIv3 金鑰（留空或 *** 不改）',
  'pages.systemConfig.recharge.certSerialNo': '商戶證書序列號',
  'pages.systemConfig.recharge.privateKeyPath': '商戶私鑰 PEM 路徑',
  'pages.systemConfig.recharge.notifyUrl': '支付結果 notify_url',
  'pages.systemConfig.recharge.refundNotifyUrl': '退款 notify_url（可選）',
  'pages.systemConfig.recharge.feeRate': '費率 fee_rate',
  'pages.systemConfig.recharge.feeBearer': '手續費承擔 platform|user',
  'pages.systemConfig.recharge.wechatPublicKeyId': '微信支付公鑰 ID',
  'pages.systemConfig.recharge.wechatPublicKeyPath': '微信支付公鑰 PEM 路徑',
  'pages.systemConfig.recharge.disableRefundOnSimFail': '物聯充值失敗時不自動微信退款',
  'pages.systemConfig.recharge.simPlatformsDivider': '物聯平臺 sim_platforms（JSON）',
  'pages.systemConfig.recharge.simPlatformsJson': '一級代理配置物件 JSON',
  'pages.systemConfig.recharge.simPlatformsJsonInvalid': '需為合法 JSON 物件',
  'pages.systemConfig.websocketPlaceholder': 'ws://你的ip:8000',

  // 全域性錯誤提示
  'helpers.systemName.fallback': '專案模板',
  'helpers.error.loginFailed': '使用者名稱或密碼錯誤',
  'helpers.error.unauthorized': '錯誤：未登入或登入已過期，請重新登入！',
  'helpers.error.tooManyRequests': '錯誤：請求次數過多，請稍後再試！',
  'helpers.error.serverError': '錯誤：伺服器內部錯誤，請聯絡管理員！',
  'helpers.error.prefix': '錯誤：',
  'helpers.error.demoOnly': '本站僅作演示之用，無服務端！',
  'helpers.error.requestFailed': '請求失敗！',

  // services 層使用者可見錯誤
  'pages.admin.providers.error.updateParams': '更新供應商時，type 和 name 引數都不能為空',
  'pages.admin.providers.error.deleteParams': '刪除供應商時，type 和 name 引數都不能為空',
  'pages.admin.providers.error.testParams': '測試供應商時，type 和 name 引數都不能為空',
  'pages.admin.providers.error.toggleParams': '切換供應商狀態時，type 和 name 引數都不能為空',
  'pages.admin.providers.error.invalidType': '無效的供應商型別: {type}，有效型別為: {validTypes}',
  'pages.knowledgeBase.error.noTaskId': '上傳已受理但未返回任務 ID，請重新整理列表後重試',
  'pages.knowledgeBase.error.indexFailed': '文件索引失敗',
  'pages.knowledgeBase.error.processTimeout': '文件處理超時，請稍後在文件列表中檢視狀態',
};
